import { makeAutoObservable } from "mobx";

export default class Album {
    _id;
    _albumTitle;
    _groupId;
    _dateAlbum;
    _imageUrl;
    constructor({ albumTitle, groupId, dateAlbum, imageUrl }) {
        this._id = crypto.randomUUID();
        this._albumTitle = albumTitle;
        this._groupId = groupId;
        this._dateAlbum = new Date(dateAlbum);
        this._imageUrl = imageUrl;
        makeAutoObservable(this);
    }

    get id() {
        return this._id;
    }

    get albumTitle() {
        return this._albumTitle;
    }

    get groupId() {
        return this._groupId;
    }

    get dateAlbum() {
        return this._dateAlbum;
    }

    get imageUrl() {
        return this._imageUrl;
    }

    get fullDate() {
        return this._dateAlbum.toLocaleDateString('fr-FR', {
            weekday: 'long',    // ex : "lundi"
            day: 'numeric',     // ex : "6"
            month: 'long',      // ex : "mai"
            year: 'numeric'     // ex : "2025"
        });
    }

    get hint() {
        const day = this._dateAlbum.getDate();
        const month = this._dateAlbum.toLocaleDateString('fr-FR', { month: 'long' });
        const year = this._dateAlbum.getFullYear();

        let decade;
        const decadeStart = Math.floor(year / 10) * 10;
        decade = `dans les années ${decadeStart}`;

        return `Cet album est sorti un ${day} ${month}, ${decade}.`;
    }
    
    get truncatedTitle() {
        const maxLength = 20;
        if (this._albumTitle.length <= maxLength) {
            return this._albumTitle;
        }
        return this._albumTitle.substring(0, maxLength) + '...';
    }



    set albumTitle(albumTitle) {
        this._albumTitle = albumTitle;
    }

    set groupId(groupId) {
        this._groupId = groupId;
    }

    set dateAlbum(dateAlbum) {
        this._dateAlbum = new Date(dateAlbum);
    }

    set imageUrl(imageUrl) {
        this._imageUrl = imageUrl;
    }
}

